module.exports = __webpack_public_path__ + "img/multibanco.72ae479.svg";